import axios from 'axios';

// axiosClient — attaches Google JWT from sessionStorage and routes through /api proxy.
const axiosClient = axios.create({
  baseURL: '/api',
  headers: { 'Content-Type': 'application/json' },
});

axiosClient.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('id_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosClient.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      sessionStorage.removeItem('id_token');
      window.location.href = '/login';
    }
    if (err.response?.status === 403 && err.config?.url?.includes('/marketing-materials')) {
      window.location.href = '/access-denied';
    }
    return Promise.reject(err);
  }
);

export default axiosClient;
